"use client"

import React from "react"
import classNames from "classnames"
import { useSession } from "next-auth/react"

import { Label } from "@fsg/gui-bits"
import { Logo } from "@fsg/svg"

import { NameBubble } from "@app/components/NameBubble"
import { OmniBox } from "@app/components/OmniBox"
import styles from "@app/styles/Header.module.scss"

import { MobileNavSheet } from "./Navbar"
import { SidebarTrigger } from "./ui/sidebar"

type Props = {
  className?: string
}

export function Header(props: Props) {
  const { data: sessionData } = useSession()
  const { className } = props
  return (
    <header
      id="app-header"
      className={classNames(
        "relative flex gap-3xs items-center justify-between pt-md pb-sm px-xs lg:px-lg min-h-[var(--header-height)]",
        styles.root,
        className
      )}
    >
      {/* <div className="flex items-center gap-3xs pr-lg md:w-[170px] lg:w-[225px]">
        <MobileNavSheet />
      </div> */}
      <SidebarTrigger className="flex lg:hidden" />
      <div className="flex-grow pr-lg">
        <OmniBox />
      </div>
      <div className="flex items-center gap-xl text-3xl">
        <NameBubble user={sessionData?.user} />
      </div>
    </header>
  )
}
